// import homecook_logo from '../assets/img/homecook_logo.png'
// import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import NewSearch from '../molecules/NewSearch';

import { useAuthState } from '../contexts/authcontext'
import { useAppState } from "../contexts/appcontext";
// import { capitalizeString } from '../utils/helpers';
import { isResourcePath } from '../utils/helpers';
import UserAvatar from "./UserAvatar";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import { ReactComponent as NotificationIcon } from "../icons/Notification.svg";
import { ReactComponent as ClickedNotificationIcon } from "../icons/ClickedNotificationIcon.svg";
import { useLoadAuthUser } from '../hooks/authhooks';
// import { ArrowDropDownOutlined } from '@mui/icons-material';

const Navbar = () => {

  const location = useLocation()
  const currentLocation = location.pathname
  var { isloggedin, isverified, authUser } = useAuthState()
  const { isCollapsed } = useAppState()

  const [searchTerm, changeSearchTerm] = useState("")
  const [userOptions, toggleUserOptions] = useState<boolean>(false);
  const [notificationClicked, setNotificationClicked] = useState(false);
  const [isBeta, setIsBeta] = useState(false);

  const notifications: any[] = [];
  const notificationCount = notifications.length;

  const getPathName = (input: string): string => {
    if (input.includes("leads")) {
      return "Leads CRM"
    }
    return input.replace("/", "").replace(/^\w/, (c) => c.toUpperCase());
  }

  var currentPageName = getPathName(currentLocation)
  const resourceType = isResourcePath(currentPageName)
  const isLeadsRoute = currentLocation.startsWith('/leads')
  // currentPageName = currentPageName ? (resourceType ? `Manage ${capitalizeString(resourceType)}` : currentPageName) : "Dashboard"
  currentPageName = currentPageName ? (resourceType ? `Resources` : currentPageName) : "Dashboard"
  currentPageName = currentLocation.includes("self-service") ? "Self-Service" : currentPageName

  const toggleNotifications = () => {
    setNotificationClicked((prev) => !prev);
  };


  const loggedinUsername = authUser && authUser?.username ? authUser.username : "";

  var isOtpFormView = isloggedin && !isverified

  /** Horizontal placement of the fixed bar, matching the sidebar offset when the sidebar is rendered. */
  const barOffsetClass = isOtpFormView
    ? 'left-0 right-0'
    : isCollapsed
      ? 'left-[90px] right-0'
      : 'left-[250px] right-0'


  useEffect(()=> {
      const checkBetaInURL = () => {
          const currentURL = window.location.href.toLowerCase();
          return currentURL.includes('beta') || currentURL.includes('localhost') || currentURL.includes('homecook.space');
      };
      setIsBeta(checkBetaInURL());
  }, [])


  return (loggedinUsername && !isOtpFormView) ? (
    <>
      <div className={`flex flex-row bg-[#FFF] border-[1px] border-[#E9E9E9] fixed top-0 z-10 h-[72px] items-center justify-between gap-4 px-6 min-w-0 ${barOffsetClass}`}>
          <div className="flex items-center shrink-0 min-w-0">
              <h1 className='text-ink text-xl font-raleway font-bold truncate'>{(isloggedin && !isOtpFormView) ? currentPageName : ""}</h1>
              {/* Add Beta Tag */}
              {(isBeta) && (
                  <div className="flex items-center gap-1 bg-gradient-to-r from-primary-400 to-primary-300 text-white px-2 py-0.5 rounded-full shadow-md ml-2">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z" />
                      </svg>
                      <span className="font-medium text-xs tracking-wide font-open-sans">BETA</span>
                  </div>
              )}
          </div>
          <div className="flex-1 min-w-0 max-w-2xl mx-4 sm:mx-8">
            {!isLeadsRoute ? (
              <div className="flex items-center min-w-0 w-full">
                <NewSearch searchType={currentPageName} searchTerm={searchTerm} changeSearchTerm={changeSearchTerm} />
              </div>
            ) : null}
          </div>

          <div className="flex items-center space-x-4 shrink-0">
            {!isLeadsRoute ? (
              <div
                className="flex items-center justify-center border-[1px] border-[#E9E9E9] rounded-2xl h-9 w-9 cursor-pointer relative"
                onClick={toggleNotifications}
              >
                {
                  notificationClicked ? (
                    <ClickedNotificationIcon className="text-[#013847] h-[22px] w-[22px]" />
                  ) : (
                    <NotificationIcon className="text-[#A1A1A1] h-[22px] w-[22px]" />
                  )
                }
                {
                  (notificationCount > 0) && (
                    <div className="absolute -top-1 -right-1 text-white text-[11px] flex items-center justify-center font-medium w-4 h-4 bg-red-500 rounded-full">
                      {notificationCount}
                    </div>
                  )
                }
              </div>
            ) : null}
          
            <div className='flex items-center space-x-2 font-open-sans'>
              <UserAvatar
                firstName={authUser?.first_name}
                lastName={authUser?.last_name}
                username={authUser?.username}
                email={authUser?.email}
                avatar={authUser?.avatar}
                size="md"
                onClick={() => toggleUserOptions(prev => !prev)}
              />

              <div
                className="flex flex-col cursor-pointer font-open-sans"
                onClick={() => toggleUserOptions(prev => !prev)}
              >
                <p className="text-ink text-sm font-medium">
                  Hi, {authUser && authUser?.first_name ? authUser.first_name : ""}
                </p>
                <p className="text-[#4D4D4D] text-xs hidden sm:block">
                  {loggedinUsername}
                </p>
              </div>

              <button 
                onClick={() => toggleUserOptions(prev => !prev)}
                className="focus:outline-none"
              >
                {userOptions ? (
                  <KeyboardArrowUpIcon className="text-[#737373] hover:text-primary-200" />
                ) : (
                  <KeyboardArrowDownIcon className="text-[#737373] hover:text-primary-200" />
                )}
              </button>
            </div>
          </div>
      </div>

      {userOptions ? (
        <div
          onMouseLeave={() => toggleUserOptions(false)}
          className="flex justify-evenly text-left h-auto absolute bg-[#fff] p-2 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] min-w-[150px] py-1 border-[1px] border-[#E9E9E9] top-16 right-0 z-50 transform transition-all duration-200 ease-in-out mr-1"
        >
          <ProfileMenuList />
        </div>
      ) : (
        <></>
      )}
    </>
  ) : (
    <>
    <div className={`flex flex-row bg-[#FFF] border-[1px] border-[#E9E9E9] fixed top-0 z-10 h-[72px] px-6 ${barOffsetClass}`}>
      <h1 className='text-ink text-[20px] font-raleway font-bold my-auto'>Partner Dashboard</h1>
        {/* Add Beta Tag */}
        {
          (isBeta) && (
            <div className="flex items-center gap-1 bg-gradient-to-r from-primary-400 to-primary-300 text-white px-2 py-0.5 rounded-full shadow-md my-auto ml-1 scale-90">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z" />
                </svg>
                <span className="font-medium text-xs tracking-wide font-open-sans">BETA</span>
            </div>
          )
        }
        <div className='flex flex-row justify-evenly items-center my-auto ml-auto text-xs'>

        <UserAvatar
          firstName={authUser?.first_name}
          lastName={authUser?.last_name}
          username={authUser?.username}
          email={authUser?.email}
          avatar={authUser?.avatar}
          size="md"
          className="mr-2"
          onClick={() => toggleUserOptions(prev => !prev)}
        />

          <div
            className="flex flex-col cursor-pointer mr-2 font-open-sans"
            onClick={() => toggleUserOptions(prev => !prev)}
          >
            {authUser?.first_name ? (
                <p className="text-ink font-medium">
                Hi, {authUser.first_name}
              </p>
            ) : null}
            <p className="my-auto text-[#4D4D4D] hidden sm:block">
              {loggedinUsername}
            </p>
          </div>

          {
            userOptions ? (
              <KeyboardArrowUpIcon
                className="text-[#737373] hover:text-primary-200 cursor-pointer"
                onClick={() => toggleUserOptions(prev => !prev)}
              />
            ) : (
              <KeyboardArrowDownIcon
                className="text-[#737373] hover:text-primary-200 cursor-pointer"
                onClick={() => toggleUserOptions(prev => !prev)}
              />
            )
          }

        </div>

    </div>

    {userOptions ? (
      <div
        onMouseLeave={() => toggleUserOptions(false)}
        className="flex justify-evenly text-left h-auto absolute bg-[#fff] p-2 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] min-w-[150px] py-1 border-[1px] border-[#E9E9E9] top-16 right-0 z-50 transform transition-all duration-200 ease-in-out mr-1"
      >
        <ProfileMenuList />
      </div>
    ) : (
      <></>
    )}
  </>
  )
}


const profileMenuList = [
  // {
  //   name: "profile",
  //   label: "My profile",
  //   Icon: UserIcon,
  //   color: "#000000",
  // },
  // {
  //   name: "saved",
  //   label: "Saved Resources",
  //   Icon: HeartIcon,
  //   color: "#000000",
  // },
  // {
  //   name: "wallet",
  //   label: "Wallet",
  //   Icon: WalletIcon,
  //   color: "#000000",
  // },
  {
    name: "logout",
    label: "Logout",
    Icon: LogoutIcon,
    color: "#D42620",
  },
];


const ProfileMenuList = () => {
  const navigate = useNavigate();
  const { signOutUser } = useLoadAuthUser();

  return (
    <div className="py-1 text-center transition cursor-default w-auto my-auto mx-2">
      {profileMenuList &&
        profileMenuList.map((item, i) => {
          return (
            <div
              key={i}
              className={`flex flex-row text-[${item.color}] w-full my-4 font-raleway text-[14px] cursor-pointer hover:bg-slate-50 rounded-md`}
              style={{ color: item.color }}
              onClick={() => {
                if (item.name === "logout") {
                  signOutUser();
                  navigate("/");
                } else {
                  navigate(`/${item.name}`);
                }
              }}
            >
              <div className={`w-1/12 text-left mr-4 my-auto ${(item.name === 'logout') ? '' : ' text-primaryDark-0'}`}>
                <item.Icon />
              </div>

              <div className={`w-11/12 text-left my-auto font-semibold`}>
                {item.label}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default Navbar;
